// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';
import { Box, SpaceBetween, TextContent } from '@cloudscape-design/components';

const CfGlobalDeployStep = () => {
  return (
    <SpaceBetween size="m">
      <Box>
        <TextContent>
          <h3>Global Resources</h3>
          <p>
            The global resources template creates the following resources once
            per account:
          </p>
          <ul>
            <li>
              <strong>WorkloadDiscoveryRole</strong> — IAM role for ResourceLens
              to discover resources
            </li>
            <li>
              <strong>WorkloadDiscoveryMyApplicationsRole</strong> — IAM role
              for MyApplications functionality
            </li>
          </ul>
        </TextContent>
      </Box>
      <Box>
        <TextContent>
          <h3>Deployment Instructions</h3>
          <ol>
            <li>
              Open the AWS CloudFormation console in your target account
            </li>
            <li>Create a new stack using the Global Resources template</li>
            <li>
              Use default parameters (recommended) or customize as needed
            </li>
            <li>Deploy the stack</li>
          </ol>
        </TextContent>
      </Box>
    </SpaceBetween>
  );
};

export default CfGlobalDeployStep;
